import classNames from "classnames";
import React, { useEffect } from "react";
import Debug from "../../theme/debug/Debug.jsx";
import styles from "./container.module.scss";

// standard styles, imported globally here
import '../../../styles/_vars.scss';

type ContainerProps = {
  children: React.ReactNode,
  inputDisabled?: boolean,
  fillBrowser?: boolean,
  debug?: boolean
}

/**
 * The main full-page container
 * @param {React.ReactNode} props.children
 * @param {Boolean} props.inputDisabled
 * @param {Boolean} props.fillBrowser
 * @param {Boolean} props.debug
 * @returns {JSX.Element}
 */
export const Container: React.FC<ContainerProps> = ({ children, inputDisabled = false, fillBrowser = true, debug = false }) => (
  <div
    id={'adminContainer'}
    className={classNames(
      styles.container,
      inputDisabled ? styles.disableInput : ""
    )}
  >
    <BodyReset />
    <div
      className={classNames(
        styles.background,
        fillBrowser ? styles.backgroundFillBrowser : ""
      )}
    />
    {debug && <Debug />}
    {children}
  </div>
);

const BodyReset = () => {
  useEffect(() => {
    document.head.innerHTML +=
      '<style type="text/css">body, html, #root { height: 100%; overflow: auto; background: #1e2125; }</style>';
  }, []);
  return <></>;
};
